/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendD8ByProductResponseDto } from '../../models/backend-d-8-by-product-response-dto';

export interface GetByProductDashboardsD8ByProductGet$Params {
  /**
   * ID проекта (обязательно)
   */
  project_id: number;

  /**
   * ID сценария; дефолт — активный
   */
  scenario_id?: number | null;

  /**
   * Начало периода YYYY-MM-DD
   */
  from?: string | null;

  /**
   * Конец периода YYYY-MM-DD
   */
  to?: string | null;

  /**
   * month — помесячно, year — годовая агрегация
   */
  granularity?: 'month' | 'year';
}

export function getByProductDashboardsD8ByProductGet(
  http: HttpClient,
  rootUrl: string,
  params: GetByProductDashboardsD8ByProductGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendD8ByProductResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getByProductDashboardsD8ByProductGet.PATH, 'get');
  if (params) {
    rb.query('project_id', params.project_id, {});
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('granularity', params.granularity, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendD8ByProductResponseDto>;
    }),
  );
}

getByProductDashboardsD8ByProductGet.PATH = '/dashboards/d8/by-product';
